import { StandaloneComponent } from '@/types/component';
import { StandaloneTrendingMenu, StandaloneTrendingMenuProps } from 'base/components/TrendingMenu';
import mergeProps from 'lib/utils/mergeProps';

const AllasStandaloneTrendingMenu: typeof StandaloneTrendingMenu = (props) => (
  <StandaloneTrendingMenu {...mergeProps({ options: { $tag: { size: 'medium' } } }, props)} />
);

export default AllasStandaloneTrendingMenu;
